import React from 'react';
import './App.css';
import AppRoutes from './routes/web';

function App() {
  return (
    <div className="App">
       <AppRoutes />
    </div>
  );
}

export default App;
